var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPaymentIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 21,
    viewBox: "0 0 26 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.8 16.9203L20.2 19.3203L25 14.5203M25 7.32031H1M25 9.72031V5.16031C25 3.81619 25 3.14413 24.7384 2.63074C24.5083 2.17915 24.1412 1.812 23.6896 1.5819C23.1762 1.32031 22.5041 1.32031 21.16 1.32031H4.84C3.49587 1.32031 2.82381 1.32031 2.31042 1.5819C1.85883 1.81199 1.49168 2.17915 1.26158 2.63074C1 3.14412 1 3.81619 1 5.16031V14.2803C1 15.6244 1 16.2965 1.26158 16.8099C1.49168 17.2615 1.85883 17.6286 2.31042 17.8587C2.82381 18.1203 3.49587 18.1203 4.84 18.1203H13",
    stroke: "#1E1E1E",
    strokeOpacity: 0.5,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentIcon);
export default __webpack_public_path__ + "static/media/paymentIcon.6183c89fe6e337b8d01394fdd2499476.svg";
export { ForwardRef as ReactComponent };